import {
  DownOutlined,
  LogoutOutlined,
  ProfileOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useGetIdentity, useLogout } from "@refinedev/core";
import { Avatar, Dropdown, Space, theme, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { PasswordChangeDialog } from "./PasswordChangeDialog";
import { UserProfileDialog } from "./UserProfileDialog";

export const CurrentUser = () => {
  const { data: user } = useGetIdentity();
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();
  const { token } = theme.useToken();

  const [isDialogVisible, setDialogVisible] = useState(false);
  const [isUserProfileVisible, setUserProfileVisible] = useState(false);

  const showPasswordChangeDialog = () => {
    setDialogVisible(true);
  };

  const closePasswordChangeDialog = () => {
    setDialogVisible(false);
  };

  const showUserProfileDialog = () => {
    setUserProfileVisible(true);
  };

  const closeUserProfileDialog = () => {
    setUserProfileVisible(false);
  };

  const items = [
    {
      icon: <SettingOutlined />,
      label: t("header.updatepassord", "Update Password"),
      key: "updatepassord",
    },
    {
      type: "divider",
    },
    {
      icon: <ProfileOutlined />,
      label: t("header.updatepassord", "User profile"),
      key: "updateuserprofile",
    },
    {
      type: "divider",
    },
    {
      icon: <LogoutOutlined />,
      label: t("header.logout", "Logout"),
      key: "logout",
    },
  ];

  const onClick = ({ key }) => {
    if (key === "logout") {
      logout();
    } else if (key === "updatepassord") {
      showPasswordChangeDialog();
    } else if (key === "updateuserprofile") {
      showUserProfileDialog();
    }
  };

  const avatarControl = () => {
    if (user?.avatar) {
      return <Avatar src={user.avatar} size='small' alt={user.name} />;
    } else {
      return <Avatar icon={<UserOutlined />} size='small' alt={user?.name} />;
    }
  };

  return (
    <>
      <Dropdown menu={{ items, onClick }} trigger={["click"]}>
        <a style={{ color: token.colorTextHeading }} onClick={(e) => e.preventDefault()}>
          <Space>
            { avatarControl() }
            {user?.name && (
              <Typography.Text strong>{user.name}</Typography.Text>
            )}
            <DownOutlined/>
          </Space>
        </a>
      </Dropdown>
      <PasswordChangeDialog
        visible={isDialogVisible}
        onClose={closePasswordChangeDialog}
      />
      <UserProfileDialog
        visible={isUserProfileVisible}
        onClose={closeUserProfileDialog}
      />
    </>
  );
};
